<div class="spinner" i18n>Loading...</div>
